// ABOUTME: Per-child crossing list + entry gate for a single dashboard child tab (Issue #1939).
// ABOUTME: Wraps useCrossings in its own component so the hook isn't called inside a .map().

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { useCrossings } from '../../hooks/useCrossings';
import CrossingList from './CrossingList';
import CrossingEntryDialog from './CrossingEntryDialog';

interface CrossingListForChildProps {
  childId: number;
  familyTimezone?: string;
}

export default function CrossingListForChild({ childId, familyTimezone }: CrossingListForChildProps) {
  const { items, error } = useCrossings({ mode: 'parent', childId, familyTimezone });
  const [openCrossingId, setOpenCrossingId] = useState<number | null>(null);
  const navigate = useNavigate();

  if (error) {
    return <Typography variant="body2" color="error">Couldn&apos;t load crossings</Typography>;
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <>
      <CrossingList items={items} onOpen={setOpenCrossingId} />
      {openCrossingId != null && (
        <CrossingEntryDialog
          open
          crossingId={openCrossingId}
          onDismiss={() => setOpenCrossingId(null)}
          onConfirm={(id) => navigate(`/crossing/${id}`, { state: { returnToChildId: childId } })}
        />
      )}
    </>
  );
}
